import { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import MultinationalTabs from '../../../components/MultinationalTabs';
import TextEditor from '../../../components/TextEditor/TextEditor';
import {
    updateTermsOfUse,
    allPolicices,
    policicesLoadingStatus,
    getPolicies,
} from '../../../redux/slices/settingsSlice';

export default function TermsOfUseSettingsPage() {
    const dispatch = useDispatch();
    const policices = useSelector(allPolicices);
    const policicesStatus = useSelector(policicesLoadingStatus);

    const countriesLocalizationsData = useMemo(
        () =>
            policices?.reduce((acc, el) => {
                acc[el.lang] = { terms_of_use: el.terms_of_use };
                return acc;
            }, {}),
        [policices],
    );

    const [data, setData] = useState({
        policies: {
            sv: {
                terms_of_use: '',
            },
            no: {
                terms_of_use: '',
            },
            fi: {
                terms_of_use: '',
            },
            da: {
                terms_of_use: '',
            },
            en: {
                terms_of_use: '',
            },
            is: {
                terms_of_use: '',
            },
        },
    });

    useEffect(() => {
        setData({
            policies: {
                sv: {
                    terms_of_use: countriesLocalizationsData?.sv?.terms_of_use,
                },
                no: {
                    terms_of_use: countriesLocalizationsData?.no?.terms_of_use,
                },
                fi: {
                    terms_of_use: countriesLocalizationsData?.fi?.terms_of_use,
                },
                da: {
                    terms_of_use: countriesLocalizationsData?.da?.terms_of_use,
                },
                en: {
                    terms_of_use: countriesLocalizationsData?.en?.terms_of_use,
                },
                is: {
                    terms_of_use: countriesLocalizationsData?.is?.terms_of_use,
                },
            },
        });
    }, [countriesLocalizationsData]);

    const onChangeMultinational = (text, flag) => {
        const newData = {
            ...data,
            policies: { ...data.policies, [flag]: { terms_of_use: text } },
        };

        setData(newData);
    };

    const onSave = async () => {
        await dispatch(updateTermsOfUse(data)).unwrap();
        toast.success('Data has been saved successfully');
        dispatch(getPolicies());
    };

    return (
        <MultinationalTabs>
            <TextEditor
                onChange={onChangeMultinational}
                data={data}
                onSave={onSave}
                isDataLoading={policicesStatus === 'loading'}
                currentPage="terms_of_use"
                title="Terms of Use"
                initialData={countriesLocalizationsData}
            />
        </MultinationalTabs>
    );
}
